module.exports = __webpack_public_path__ + "static/media/soundboard.e7f23008.png";